import { Progress } from "@/components/ui/progress";
import { TabsContent } from "@/components/ui/tabs";
import { EmptyState } from "@/components/bits";

export function OnboardingTab({ onboarding }) {
  return (
    <TabsContent value="onboarding">
      {onboarding.length === 0 ? (
        <EmptyState title="No onboarding in progress" description="A checklist is created automatically when a candidate joins." testId="onboarding-empty" />
      ) : (
        <div className="space-y-3" data-testid="onboarding-list">
          {onboarding.map((ob) => (
            <div key={ob.id} className="bg-white border border-border/60 rounded-xl p-5" data-testid={`onboarding-${ob.id}`}>
              <div className="flex items-center justify-between mb-3">
                <p className="font-semibold text-sm text-[#0B1B3D]">{ob.employee_name}</p>
                <span className="text-xs font-bold text-[#2563EB]">Onboarding {ob.progress}% complete</span>
              </div>
              <Progress value={ob.progress} className="h-2" />
              <div className="flex gap-1.5 flex-wrap mt-3">
                {ob.items.map((i) => (
                  <span key={i.key} className={`text-[10px] rounded-full px-2 py-0.5 font-medium ${i.status === "completed" ? "bg-emerald-100 text-emerald-700" : "bg-slate-100 text-slate-500"}`}>
                    {i.label}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </TabsContent>
  );
}
